// extracted by mini-css-extract-plugin
export var actions = "_4o-0";
export var actionsContainer = "_4o-7";
export var border = "_4o-1";
export var childFullHeight = "_4o-f";
export var collapse = "_4o-2";
export var content = "_4o-a";
export var contentChild = "_4o-e";
export var fullscreen = "_4o-c";
export var hasLeftRadius = "_4o-k";
export var headerContainer = "_4o-3";
export var headerRow = "_4o-5";
export var hidePadding = "_4o-b";
export var navCollapsedGap = "_4o-l";
export var noScrollX = "_4o-m";
export var noScrollY = "_4o-n";
export var noTopPadding = "_4o-i";
export var optOutTopPadding = "_4o-d";
export var pageMain = "_4o-j";
export var pageOuter = "_4o-g";
export var pagePadding = "_4o-8";
export var pageScroll = "_4o-9";
export var profile = "_4o-o";
export var profileContainer = "_4o-p";
export var profileImage = "_4o-q";
export var profileMain = "_4o-r";
export var profileSubtitle = "_4o-t";
export var profileTitle = "_4o-s";
export var showLeftPadding = "_4o-h";
export var tabsPortalSlot = "_4o-6";
export var tabsWrapper = "_4o-4";
export var title = "_4o-u";